import { Component, Input, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-events-stat-hint-icon',
    templateUrl: './events-stat-hint-icon.component.html',
    styleUrls: ['./events-stat-hint-icon.component.scss']
})
export class EventsStatHintIconComponent implements OnInit {
    @Input()
    placement: string = 'top';

    @Input()
    hintIconClass: string = '';

    constructor() {}

    ngOnInit(): void {}

    tooltipValue = `
  <p class="process-stat-popover-row"><b>Work Time:</b> Total duration of all “active” periods. Active period is the period between the "Process started" event and other events ("Process stopped", "Process deleted", "Process finished") or current time if a period has not ended.</p>
  <p class="process-stat-popover-row"><b>Life Time:</b> Total process existence duration from "Process created" and "Process deleted event" or the current time if the process is still running.</p>
  <p class="process-stat-popover-row"><b>Waiting Time:</b> Total duration of all periods when the process was not active. (Life Time - Work Time).</p>
  <p class="process-stat-popover-row"><b>Created:</b> The date the process was created.</p>
  <p class="process-stat-popover-row"><b>Finished:</b> The date the process was completed.</p>
  <p class="process-stat-popover-row"><b>Deleted:</b> The date the process was deleted.</p>
  `;
}
